const { appendFilter } = require('../../../queries');
const addAutopayScheduledTransactionsQueries = require('../../../queries/configs/AutopayScheduledTransactions');

module.exports = addAutopayScheduledTransactionsQueries(function ({ autopayId }) {
  return ({
    queriesFilter: appendFilter('autopayId', autopayId),
  })
});
